<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 15:30:10
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:34:56
-->
<template>
  <div class="mini-tabs-base">
    <div class="tab-item" :class="{ disabled: checkDisabled(DOC_ID) }" @click="onClickTab(DOC_ID)">
      <img class="tab-item-icon" :src="docIcon" />
      <span class="label" :class="{ active: checkActive(DOC_ID) }">{{ checkActive(DOC_ID) ? '关闭文稿' : '打开文稿' }}</span>
    </div>
    <!-- <div class="tab-item" :class="{ disabled: checkDisabled(HEART_ID) }" @click="onClickTab(HEART_ID)">
      <img class="tab-item-icon" :src="heartIcon" />
      <span class="label" :class="{ active: checkActive(HEART_ID) }">{{ checkActive(HEART_ID) ? '已收藏' : '收藏' }}</span>
    </div> -->
  </div>
</template>

<script>
import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID } = configFields;
export default {
  props: {
    disabled: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Object,
      default: () => ({
        [DOC_ID]: false,
        [HEART_ID]: false,
      }),
    },
  },
  data() {
    return {
      selfDisabled: [],
      DOC_ID,
      HEART_ID,
      selfActive: {},
    };
  },
  activated() {
    this.selfDisabled = this.disabled;
    this.selfActive = this.active;
  },
  watch: {
    disabled(arr) {
      this.selfDisabled = arr;
    },
    active: {
      handler(obj) {
        this.selfActive = obj;
      },
      deep: true,
    },
  },
  computed: {
    docIcon() {
      let iconName = this.checkActive(DOC_ID) ? 'doc-light' : 'doc';
      iconName = this.selfDisabled.includes(DOC_ID) > 0 ? 'doc-grey' : iconName;
      return require(`@/assets/imgs/icon/${iconName}.png`);
    },
    heartIcon() {
      return require(`@/assets/imgs/icon/${this.checkActive(HEART_ID) ? 'heart-light' : 'heart'}.png`);
    },
  },
  methods: {
    checkDisabled(id) {
      return this.disabled.includes(id);
    },
    onClickTab(id) {
      if (this.checkDisabled(id)) return;
      // 截流
      if (this._riverClosure('tab', 800)) {
        this.$emit('onClickTab', id);
      }
    },
    checkActive(id) {
      return !!this.selfActive[id];
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-tabs-base {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .tab-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 70px;
    background: $C1;
    cursor: pointer;
    user-select: none;
    &-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      display: inline-block;
    }
    &.disabled {
      color: $C5;
      cursor: default;
    }
    .label.active {
      color: $C2;
    }
  }
}
</style>
